export default __webpack_public_path__ + "static/media/govMinas.9a1047e3.png";